/* Import Css Style */
import './styles/Focus2.css'
/* Components imports */
import {Header_Focus2} from "../subComponents/Header_Focus2";
/* Import React */
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRightLong} from "@fortawesome/free-solid-svg-icons";
/* Import Assets */

export const Focus2 = () =>{


    let scrollNextF2 = () => {
        document.querySelector('.Focus3_Container').scrollIntoView({behavior: "smooth"
            , block: 'center'
        })
    }


    return(
        <section class="Focus2_Container">

<Header_Focus2/>
            <div style={{cursor: 'pointer', display: 'none'}} onClick={scrollNextF2} className="ScrollDownBiggestContainer">
                <div className="ScrollDown">
                    S C R O L L
                </div>
                <div className="ArrowDownLongScroll">
                    <FontAwesomeIcon icon={faArrowRightLong}/>
                </div>
            </div>

        </section>
    )
}
